import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { ODataService } from "src/app/core/services/odata.service";


@Injectable({ providedIn: null })
export class TenantMappingService extends ODataService<TenantMapping> {
  private httpClient = inject(HttpClient);

  constructor() {
    const url = `${environment.apiUrl}/v1/ticketintegration/administrative/tenant_mappings/`;
    super(inject(HttpClient), url);

    this.state = {
      skip: 0,
      take: 10,
      sort: [{ field: 'organization_name', dir: 'asc' }],
      filter: {
        logic: 'and',
        filters: [],
      },
    };
  }

  upsert(tenantMapping: TenantMapping): Observable<TenantMapping> {
    const url = `${environment.apiUrl}/v1/ticketintegration/administrative/tenant_mappings/upsert/`;

    const payload: TenantMappingUpsertRequest = {
      id: tenantMapping.id,
      primary_organization_id: tenantMapping.primary_organization_id!,
      organization_id: tenantMapping.organization_id!,
      company_id: tenantMapping.company_id!,
      company_name: tenantMapping.company_name!,
      agreement_id: tenantMapping.agreement_id ?? null,
      agreement_name: tenantMapping.agreement_name ?? null
    };

    return this.httpClient.post<TenantMapping>(url, payload);
  }

  delete(id: number): Observable<void> {
    const url = `${environment.apiUrl}/v1/ticketintegration/administrative/tenant_mappings/${id}/`;
    return this.httpClient.delete<void>(url);
  }
}

export class TenantMapping {
  id: number | null = null;
  primary_organization_id: number | null = null;
  organization_id: number | null = null;
  company_id: number | null = null;
  company_name: string | null = null;
  agreement_id: number | null = null;
  agreement_name: string | null = null;
  created_at: string | null = null;
  created_by_id: number | null = null;
  updated_at: string | null = null;
  primary_organization_name: string | null = null;
  organization_name: string | null = null;
}

export interface TenantMappingResponse {
 "@odata.count": number;
  value: TenantMapping[];
}

export interface TenantMappingUpsertRequest {
  id: number | null;
  primary_organization_id: number;
  organization_id: number;
  company_id: number;
  company_name: string;
  agreement_id: number | null;
  agreement_name: string | null;
}
